import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import { Breadcrumbs } from '@/ui/kit/components/breadcrumbs';
type PageWithBreadCrumbsProps = {
  children: ReactNode;
  breadCrumbLastItem?: string;
};
const PageWithBreadCrumbs = ({
  children,
  breadCrumbLastItem
}: PageWithBreadCrumbsProps): JSX.Element => {
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    px: 0,
    pt: {
      xs: 'unset',
      md: `${24}px`
    },
    pb: '80px',
    maxWidth: '1200px',
    margin: 'auto',
    flex: 1,
    width: '100%'
  }} data-sentry-element="Box" data-sentry-component="PageWithBreadCrumbs" data-sentry-source-file="PageWithBreadcrumbs.tsx">
      <Breadcrumbs sx={{
      display: {
        md: 'block',
        xs: 'none'
      },
      pb: '24px'
    }} lastItem={breadCrumbLastItem} data-sentry-element="Breadcrumbs" data-sentry-source-file="PageWithBreadcrumbs.tsx" />
      {children}
    </Box>;
};
export default PageWithBreadCrumbs;